import VueRouter, { RouteConfig } from 'vue-router'
const Index = () => import('../views/ai-chat/Index.vue')

export const aiChatRoute: RouteConfig = {
  path: '/ai-chat',
  name: 'ai_chat',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '小体助教',
  },
}
export default [aiChatRoute]

export function navigateToAIChat(router: VueRouter) {
  router.push({ name: aiChatRoute.name })
}
